import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiservicepune() {



const cardData = {
  keyword: " Outstation Taxi Service Pune",

"headingDescription": "SRS Cab Service offers Outstation Taxi Service Pune, providing comfortable, safe, and reliable long-distance travel for families, tourists, and corporate clients. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth and hassle-free journey from Pune to popular outstation destinations. Ideal for weekend getaways, business trips, and holiday travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and enjoyable travel experience.",
"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for its scenic valleys and waterfalls. Travelers using SRS Cab Service often visit for weekend getaways and nature views."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill station known for strawberry farms and viewpoints. Visitors using SRS Cab Service often explore this destination for relaxation and sightseeing."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba. Travelers using SRS Cab Service often visit for spiritual trips and temple darshan."
  },
  {
    "title": "Nashik",
    "description": "Nashik is known for temples, vineyards, and religious significance. Visitors using SRS Cab Service often travel here for both tourism and pilgrimage."
  },
  {
    "title": "Mumbai",
    "description": "Mumbai is India’s financial capital known for its landmarks and nightlife. Travelers using SRS Cab Service often visit for business trips and city exploration."
  },
  {
    "title": "Alibag",
    "description": "Alibag is a coastal town known for its beaches and forts. Visitors using SRS Cab Service often plan beach trips and weekend holidays here."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur is known for Mahalakshmi Temple and rich culture. Travelers using SRS Cab Service often visit for pilgrimage and local experiences."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is famous for Ajanta and Ellora caves. Visitors using SRS Cab Service often explore this city for historical sightseeing."
  },
  {
    "title": "Goa",
    "description": "Goa is a popular tourist destination known for beaches and nightlife. Travelers using SRS Cab Service often plan long trips for holidays and relaxation."
  },
  {
    "title": "Satara",
    "description": "Satara is known for natural beauty and waterfalls. Visitors using SRS Cab Service often visit for short scenic trips from Pune."
  }
],



services: [
{
name: "Outstation Taxi Service Pune",
description: "Outstation taxi service Pune offers reliable travel for long-distance journeys. Customers can book taxis for tours and business trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation taxi services in Pune."
},
{
name: "Outstation Cabs Pune",
description: "Outstation cabs Pune provide convenient travel options for intercity trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "One Way Cab Pune",
description: "One way cab Pune offers economical travel without return charges. Customers can book direct rides for long-distance trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Best Outstation Cab Service in Pune",
description: "Best outstation cab service in Pune offers top-rated transportation for customers. Travelers can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Outstation Cab Service in Pune",
description: "Outstation cab service in Pune provides dependable transportation for long trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Outstation Car Rental Pune",
description: "Outstation car rental Pune offers flexible vehicle options for long-distance travel. Customers can rent cars for personal and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with car rental services."
},
{
name: "Taxi in Pune for Outstation",
description: "Taxi in Pune for outstation provides convenient travel for intercity trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking in Pune for Outstation",
description: "Cab booking in Pune for outstation offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Book Outstation Cabs Pune",
description: "Book outstation cabs Pune provides easy booking solutions for long-distance travel. Customers can reserve cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Taxi Service in Pune for Outstation",
description: "Taxi service in Pune for outstation offers reliable transportation for long-distance trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Intercity Cab Service in Pune",
description: "Intercity cab service in Pune provides convenient travel between cities. Customers can book cabs for business and leisure trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with intercity cab services."
},
{
name: "Outstation Taxi Service in Pune",
description: "Outstation taxi service in Pune offers dependable travel for long-distance routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Outstation Taxi in Pune",
description: "Outstation taxi in Pune provides reliable travel solutions for intercity journeys. Customers can book taxis for flexible trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune Airport to Kolhapur Cab",
description: "Pune airport to Kolhapur cab offers convenient travel for long-distance journeys. Customers can book cabs for direct airport pickup and drop. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Outstation Taxi",
description: "Pune to outstation taxi provides reliable transportation for long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Innova Crysta on Rent in Pune",
description: "Innova Crysta on rent in Pune offers premium SUV travel for outstation trips. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta."
},
{
name: "Tempo Traveller on Rent for Outstation",
description: "Tempo traveller on rent for outstation provides group travel solutions for tours. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Ertiga on Rent in Pune for Outstation",
description: "Ertiga on rent in Pune for outstation offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Pune to Outstation Sedan Cab Service",
description: "Pune to outstation sedan cab service provides affordable travel for individuals and small groups. Customers can book vehicles for long-distance trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Pune to Outstation Swift Cab Service",
description: "Pune to outstation swift cab service offers budget-friendly travel for long trips. Customers can book vehicles for economical journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with swift cab services."
},
{
name: "Best Outstation Taxi Service Pune",
description: "Best outstation taxi service Pune offers top-rated transportation for long-distance travel. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best taxi services."
},
{
name: "Cheap Outstation Taxi Pune",
description: "Cheap outstation taxi Pune provides budget-friendly travel for long-distance trips. Customers can book taxis at affordable rates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap taxi services."
},
{
name: "Affordable Outstation Taxi Pune",
description: "Affordable outstation taxi Pune offers cost-effective travel for intercity journeys. Customers can book taxis at competitive prices. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable taxi services."
},
{
name: "Pune Outstation Taxi Fare",
description: "Pune outstation taxi fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Outstation Taxi Price Pune",
description: "Outstation taxi price Pune provides estimated cost details for long-distance travel. Customers can compare prices before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi price services."
}
],

tableData: [
["Outstation Taxi Service Pune","Outstation Cabs Pune"],
["One Way Cab Pune","Best Outstation Cab Service in Pune"],
["Outstation Cab Service in Pune","Outstation Car Rental Pune"],
["Taxi in Pune for Outstation","Cab Booking in Pune for Outstation"],
["Book Outstation Cabs Pune","Taxi Service in Pune for Outstation"],
["Intercity Cab Service in Pune","Outstation Taxi Service in Pune"],
["Outstation Taxi in Pune","Pune Airport to Kolhapur Cab"],
["Pune to Outstation Taxi","Innova Crysta on Rent in Pune"],
["Tempo Traveller on Rent for Outstation","Ertiga on Rent in Pune for Outstation"],
["Pune to Outstation Sedan Cab Service","Pune to Outstation Swift Cab Service"],
["Best Outstation Taxi Service Pune","Cheap Outstation Taxi Pune"],
["Affordable Outstation Taxi Pune","Pune Outstation Taxi Fare"],
["Outstation Taxi Price Pune","One Way Cab Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Outstation Taxi Service from Pune",
    WhyChoosedescription: "SRS Cab Service offers dependable outstation taxi service in Pune for long-distance travel to cities like Mumbai, Nashik, Shirdi, Goa, Bangalore, and more."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly outstation taxi services with clear pricing. Customers receive complete fare details including tolls and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "Wide Range of Outstation Routes",
    WhyChoosedescription: "Our service covers multiple destinations across Maharashtra and India including hill stations, pilgrimage sites, business cities, and tourist locations."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for outstation taxi bookings in Pune, making it convenient for early departures, night travel, and emergency trips."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort and smooth travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way taxi service, round-trip bookings, or customized multi-day travel plans based on your itinerary."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for all group sizes."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted for outstation taxi service in Pune due to punctual drivers, reliable vehicles, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide outstation taxi service in Pune?", answer: "Yes, SRS Cab Service offers reliable outstation taxi services from Pune to multiple cities." },
  { question: "Which destinations are covered in outstation taxi service?", answer: "We cover destinations like Mumbai, Shirdi, Nashik, Goa, Bangalore, Hyderabad, and many more." },
  { question: "Is outstation taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for outstation travel?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way outstation taxi?", answer: "Yes, we provide both one-way and round-trip outstation taxi services." },
  { question: "How is outstation taxi fare calculated?", answer: "Fare is calculated based on per km rate, minimum daily km, toll charges, and driver allowance." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the taxi online?", answer: "Yes, you can easily book outstation taxi service in Pune online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patil",
    feedback:
      "Booked outstation taxi from Pune to Goa. Very comfortable journey and excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best outstation taxi service in Pune. Clean car, professional driver, and affordable pricing.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Outstation Taxi Service Pune - SRS Cab & Tours",
  "description": "Book reliable outstation taxi services from Pune. One-way and round-trip cabs available for intercity travel. Affordable outstation cabs and car rentals in Pune.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/outstation-cab-pune",
  "areaServed": [
    "Pune, Maharashtra",
    "Mumbai, Maharashtra",
    "Goa",
    "Aurangabad",
    "Kolhapur",
    "Hyderabad",
    "Bangalore"
  ],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹₹",
  "serviceType": [
    "Outstation Cab Service Pune",
    "One Way Cab Pune",
    "Round Trip Outstation Cab",
    "Luxury Cab Service",
    "Private Car Hire",
    "Intercity Taxi Service"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1123"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Outstation Taxi Service Pune | SRS Cab & Tours</title>
  <meta 
    name="description" 
    content="Book the best outstation taxi services in Pune. One-way, round-trip, luxury cabs & intercity taxi services. Affordable Pune outstation cabs and car rentals." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationtaxiservicepune;